export default __webpack_public_path__ + "static/media/lunge_squat_thumb.b5086bbd.png";